import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12 col-md-6 d-grid gap-2 mb-4 mt-4" }
const _hoisted_2 = ["for"]
const _hoisted_3 = { class: "select-wrapper" }
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  disabled: "",
  value: ""
}
const _hoisted_6 = ["value"]

import { FlowItem } from "@/models/Configuration/FlowItem";
import { TreeItem } from "@/models/Configuration/TreeItem";
import _ from "lodash";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'BookflowSelect',
  props: {
    nodes: {},
    title: { default: "Titolo" },
    level: {},
    selectednodes: {}
  },
  emits: ["service-selected", "reset-selection"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const props = __props;

const emit = __emit;

const selectedNode = ref<TreeItem<FlowItem>>(null);
const selectName = computed(() => {
    return "select_" + props.level;
});

const selectPlaceholder = computed(() => {
    return _.capitalize(t("titles.selectService"));
});

const recallServiceSelected = (currentNode: any) => {
    emit("service-selected", currentNode);
};

watch(
    () => props.selectednodes,
    () => {
        var elementIdForLevel = props.selectednodes[props.level];
        if (elementIdForLevel) {
            var selNode = _.find(props.nodes, function (node) {
                return node.item.id === parseInt(elementIdForLevel);
            });
            if (selNode) {
                selectedNode.value = selNode;
            }
        } else {
            selectedNode.value = null;
        }
    },
    { immediate: true }
);

watch(
    () => selectedNode.value,
    (value) => {
        if (value) {
            emit("service-selected", {
                node: value,
                level: props.level
            });
        }
    },
    { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_BookflowSelect = _resolveComponent("BookflowSelect", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", {
        for: selectName.value,
        style: {"text-align":"left"}
      }, _toDisplayString(_ctx.title), 9, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("select", {
          id: selectName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedNode).value = $event)),
          autocomplete: "off"
        }, [
          _createElementVNode("option", _hoisted_5, _toDisplayString(selectPlaceholder.value), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nodes, (node) => {
            return (_openBlock(), _createElementBlock("option", {
              style: {"padding-top":"2px","padding-bottm":"2px"},
              key: node.item.id,
              value: node
            }, _toDisplayString(node.item.name), 9, _hoisted_6))
          }), 128))
        ], 8, _hoisted_4), [
          [_vModelSelect, selectedNode.value]
        ])
      ])
    ]),
    (selectedNode.value && selectedNode.value.children && !selectedNode.value.item.isService)
      ? (_openBlock(), _createBlock(_component_BookflowSelect, {
          key: 0,
          nodes: selectedNode.value.children,
          title: selectedNode.value.item.title,
          level: _ctx.level + 1,
          onServiceSelected: recallServiceSelected,
          selectednodes: props.selectednodes
        }, null, 8, ["nodes", "title", "level", "selectednodes"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})